<template>
  <layout>
  <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
  <div class="el-form-content" slot="content">
    <el-form size="mini" label-width="80px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="상담유형">
            <el-input v-model="form.callClass" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-row>
            <el-form-item label="상담분류">
              <el-col :span="8">
                <el-input v-model="form.callCatId1" readonly></el-input>
              </el-col>
              <el-col :span="8">
                <el-input v-model="form.callCatId2" readonly></el-input>
              </el-col>
              <el-col :span="8">
                <el-input v-model="form.callCatId3" readonly></el-input>
              </el-col>
            </el-form-item>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="제조사">
            <el-input v-model="form.makerNm" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="제품군">
            <el-input v-model="form.modelGroupNm" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="대표모델">
            <el-input v-model="form.standardModelNm" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="모델">
            <el-input v-model="form.modelNm" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="문의내역">
            <el-input type="textarea" v-model="form.question" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="답변내역">
            <el-input type="textarea" v-model="form.answer" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="기타메모">
            <el-input type="textarea" v-model="form.memo" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="고객명">
            <el-input v-model="form.boundCustNm" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="연락처">
            <el-input v-model="form.callTelNo" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="처리결과">
            <el-radio-group v-model="form.callTypeNm" disabled>
              <el-radio 
                v-for="item in data.callTypeRadio"
                :key="item.key"
                :label="item.value"
                :value="item.key">
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="상담원">
            <el-input v-model="form.chargeNm" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

  </div>
</layout>
</template>

<script>
/**
* * components
*/
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';

import mixin from './index';

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

export default {
  mixins: [mixin],
  props: {
      data: {
          Type: Array
          , required: false
      },
      custNo: {
          Type: String
          , required: false
      }
  },
  components: {Layout, AgGridVue},
  data() {
      return {
          title: '일반상담상세내역',
          form: {
            modelGroupNm: '',
            callClass: '', /** 상담유형 */
            callCatId1: '', /** 상담분류(대) */
            callCatId2: '', /** 상담분류(중) */
            callCatId3: '' /** 상담분류(소) */
          },
          search: '',
          deptCd: '1',
          mobileGb: 'h',
          callClassOpt: [], /** 상담유형리스트 */
          callClassIdOpt: [], /** 상담유형리스트 Id */
          callCatIdOpt1: [], /** 상담분류(대) */
          callCatIdIdOpt1: [], /** 상담분류(대) Id */
          callCatIdOpt2: [], /** 상담분류(중) */
          callCatIdIdOpt2: [], /** 상담분류(중) Id */
          callCatIdOpt3: [], /** 상담분류(소) */
          callCatIdIdOpt3: [] /** 상담분류(소) Id */
      }
  },
  created() {
    this.form = this.data;
    this.$bus.$on('input', (val) => {
        console.log('-> input bus on ', val);
    });
  },
  mounted() {
      this.selectNormalConsultDetail()
      //pop slots modal move
      $(".animation-content").addClass('pop_min2');
      $(".animation-content").draggable({'cancel':'.modal-card-body'});
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '4');
  },
  destroyed() {
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '7');
  },
  methods: {
      
      closeModal() {
          this.$parent.close();
      },
      onGridReady(){
      
      },
      selectNormalConsultDetail(){
        if(!this.data.callId){
          return false
        }

        const vform = {
          callId: this.data.callId,
          processTime: ''
        }
        this.$store.commit('loading')
        // console.log('selectNormalConsultDetail : ', vform) 
        this.$http.post(("/api/asMng/call/selectNormalConsultDetail"), vform
            ).then(response => {
            //console.log('Normal select: ' , response)
            if(response.data && response.data.length > 0){
              
              let x = response.data[0]
              const arr1 = x.catFullNm.split('>')
              x.callClass = '' /** 상담유형 */
              x.callCatId1 = '' /** 상담분류(대) */
              x.callCatId2 = '' /** 상담분류(중) */
              x.callCatId3 ='' /** 상담분류(소) */

              if(arr1 && arr1.length > 0){
                x.callClass = arr1[0] /** 상담유형 */
                x.callCatId1 = arr1.length >=2 ? arr1[1] : '' /** 상담분류(대) */
                x.callCatId2 = arr1.length >=3 ? arr1[2] : '' /** 상담분류(중) */
                x.callCatId3 = arr1.length >=4 ? arr1[3] : '' /** 상담분류(소) */
              }

              x.callTelNo = _phone(x.callTelNo)
              x.chargeNm = x.deptNm.length > 0 ? ( x.deptNm + ' > ' + (x.chargeNm || '') ) : (x.chargeNm || '')
              
              console.log('this form2===========', x)
              this.form = x
            }
              
        }).finally(() => {
            this.$store.commit('finish')
        });
      }
      
  }

}
</script>

<style lang="scss" scoped>

.el-form-content {
  border: 1px solid #d7d7d7 !important;
  padding: 10px 10px 10px 0;
  border-radius: 5px; 
  margin-left: 0px;
    .el-form-item {
        margin-left: -5px;
        // margin-right: 0px;
    }
}
</style>